var _g, _text, _rect, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 183,
  height: 40,
  fill: "none",
  "aria-label": "FinPath Beta",
  viewBox: "0 0 509 110.9"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#72C899",
  strokeLinejoin: "round",
  strokeWidth: 2.14
}, /*#__PURE__*/React.createElement("path", {
  d: "M94.4 41.3a5.1 5.1 0 0 1 1.52 4.87l-8.21 36.26a5.1 5.1 0 0 1-3.46 3.75L48.74 97.21a5.1 5.1 0 0 1-4.98-1.13l-27.3-25.24a5.1 5.1 0 0 1-1.52-4.87l8.21-36.26a5.1 5.1 0 0 1 3.46-3.75l35.51-11.03a5.1 5.1 0 0 1 4.98 1.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.31 38.15a9.39 9.39 0 0 1 2.78 8.97l-8.2 36.26a9.39 9.39 0 0 1-6.37 6.89L50.01 101.3a9.39 9.39 0 0 1-9.16-2.07l-27.3-25.24a9.39 9.39 0 0 1-2.78-8.97l8.2-36.26a9.39 9.39 0 0 1 6.37-6.89l35.51-11.03a9.39 9.39 0 0 1 9.16 2.07Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.22 35.01a13.67 13.67 0 0 1 4.05 13.05l-8.2 36.27a13.67 13.67 0 0 1-9.28 10.03l-35.51 11.03a13.67 13.67 0 0 1-13.33-3.02L10.64 77.13a13.67 13.67 0 0 1-4.05-13.05l8.2-36.27a13.67 13.67 0 0 1 9.28-10.03L59.58 6.75a13.67 13.67 0 0 1 13.33 3.02Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.13 31.86a17.95 17.95 0 0 1 5.32 17.15l-8.21 36.26a17.95 17.95 0 0 1-12.18 13.18l-35.51 11.03a17.95 17.95 0 0 1-17.51-3.96L7.73 80.28a17.95 17.95 0 0 1-5.32-17.15l8.21-36.26A17.95 17.95 0 0 1 22.8 13.69L58.31 2.66a17.95 17.95 0 0 1 17.51 3.96Z"
}))), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 139.4,
  y: 80.8,
  fontFamily: "Rubik, 'Helvetica Neue', Arial, sans-serif",
  fontSize: 72.7,
  fontWeight: 400,
  letterSpacing: -1.82
}, /*#__PURE__*/React.createElement("tspan", {
  fill: "#6BAF8C"
}, "Fin"), /*#__PURE__*/React.createElement("tspan", {
  fill: "#25346A"
}, "Path"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 113.9,
  height: 45.6,
  x: 391,
  y: 9.1,
  fill: "#64D7A5",
  fillOpacity: 0.2,
  rx: 22.8
})), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 447.9,
  y: 44.9,
  fill: "#25346A",
  fontFamily: "Rubik, 'Helvetica Neue', Arial, sans-serif",
  fontSize: 36.4,
  fontWeight: 500,
  textAnchor: "middle"
}, "Beta\n        ")));
export default SvgLogo;